"use client";

import Image from "next/image";
import { useState } from "react";
import ScrollReveal from "../common/ScrollReveal";
import ExpandCollapseCard from "../common/ExpandCollapseCard";
import { shredItems } from "../Products/accordionContent";

const HOME_ITEMS = shredItems.slice(0, 3);

export default function Shred() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="relative w-full bg-background px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 md:pt-[70px] overflow-hidden">
      <div className="max-w-[1300px] mx-auto relative z-10">
        <ScrollReveal direction="up" delay={0}>
          <h2 className="text-white font-bold text-[32px] md:text-[44px] lg:text-[55px] leading-[1.2] lg:leading-[79px] text-center mb-5">
            <span className="relative inline-block">
              SH<span className="text-primary">RED</span> PLATFORM
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={100}>
          <div className="text-[14px] leading-[20px] tracking-[0.25px] md:text-[16px] md:leading-[28px] md:tracking-[0.5px] text-text-default text-center max-w-[1078px] mx-auto mb-5">
            <p>Software · Hardware · Research · Exploit Development</p>
            <p>A unified platform for vulnerability research</p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,675fr)_minmax(0,551fr)] gap-8 lg:gap-10 items-start">
          <div className="flex flex-col gap-4 lg:order-1 order-2">
            {HOME_ITEMS.map((item, index) => (
              <ScrollReveal
                key={item.title}
                direction="left"
                delay={200 + index * 90}
              >
                <ExpandCollapseCard
                  title={item.title}
                  headline={item.headline}
                  description={item.description}
                  isOpen={openIndex === index}
                  onToggle={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                />
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal
            direction="right"
            delay={200}
            className="lg:order-2 order-1"
          >
            {/* The 376px floor only makes sense next to the desktop card column:
                the artwork is 551x184 landscape, so on a phone it renders ~120px
                tall and the floor would leave ~256px of dead space. */}
            <div className="relative mx-auto w-full max-w-[551px] flex items-center justify-center min-h-0 sm:min-h-[376px]">
              <div className="home-float relative w-full overflow-hidden">
                <Image
                  src="/images/Home/shred.svg"
                  alt="SHRED — unified vulnerability research platform"
                  width={551}
                  height={184}
                  className="w-full h-auto"
                  priority={false}
                />
                <span className="shred-scan-line" aria-hidden />
              </div>
            </div>
          </ScrollReveal>
        </div>

      </div>
    </section>
  );
}
